import { combineReducers } from "redux";
import productReducer from "../reduxSetup/productReducer";

const rootReducer = combineReducers({
  productReducer: productReducer,
});

export default rootReducer;
